import { useEffect, useState } from "react";
import { toast } from "sonner";

import { AdminShell } from "@/components/admin/admin-shell";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { apiGet, apiPatch, apiPost } from "@/services/api";

type VendorType = { id: string; name: string; slug: string; description: string | null; isActive: boolean };

export function AdminVendorTypesPage() {
  const [types, setTypes] = useState<VendorType[]>([]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  async function load() {
    const d = await apiGet<{ vendorTypes: VendorType[] }>("/api/admin/vendor-types");
    setTypes(d?.vendorTypes ?? []);
  }
  useEffect(() => {
    void load();
  }, []);

  async function create() {
    try {
      await apiPost("/api/admin/vendor-types", { name, description });
      toast.success("Type created");
      setName("");
      setDescription("");
      void load();
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Failed");
    }
  }

  async function toggle(t: VendorType) {
    await apiPatch(`/api/admin/vendor-types/${t.id}`, { isActive: !t.isActive });
    void load();
  }

  return (
    <AdminShell title="Vendor types" subtitle="Categories of sellers allowed on the marketplace">
      <div className="amazon-card mb-6 flex flex-wrap items-end gap-3 p-5">
        <label className="text-sm">
          <span className="font-bold">Name</span>
          <input value={name} onChange={(e) => setName(e.target.value)} className="mt-1 block rounded border border-slate-300 px-3 py-2 dark:border-white/10 dark:bg-white/5" />
        </label>
        <label className="text-sm">
          <span className="font-bold">Description</span>
          <input value={description} onChange={(e) => setDescription(e.target.value)} className="mt-1 block rounded border border-slate-300 px-3 py-2 dark:border-white/10 dark:bg-white/5" />
        </label>
        <Button onClick={() => void create()} disabled={!name}>Add type</Button>
      </div>

      <div className="amazon-card divide-y divide-slate-100 dark:divide-white/10">
        {types.map((t) => (
          <div key={t.id} className="flex items-center justify-between p-4">
            <div>
              <p className="font-bold">{t.name}</p>
              <p className="text-xs text-slate-500">{t.description}</p>
            </div>
            <div className="flex items-center gap-2">
              <Badge tone={t.isActive ? "success" : "deal"}>{t.isActive ? "Active" : "Inactive"}</Badge>
              <button className="text-sm font-bold text-amazon-teal" onClick={() => void toggle(t)}>
                {t.isActive ? "Deactivate" : "Activate"}
              </button>
            </div>
          </div>
        ))}
      </div>
    </AdminShell>
  );
}
